export const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === "true";

export const CONFIG = {
  USE_MOCK_DATA,
  API_BASE_URL: import.meta.env.VITE_API_URL || "http://localhost:3310/api/v1",
};
